import { Col, Row, Descriptions, Spin, Empty } from "antd";
import React from "react";
import styles from "./CardListDatagrid.module.css";

export interface KeyObject {
    [key: string]: string | number | bigint | KeyObject | undefined;
}

interface CardListDatagridProps {
    dataSource: KeyObject[];
    columns: any[];
    loading: boolean;
}

export function CardListDatagrid({ dataSource, columns, loading }: CardListDatagridProps) {
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24}>
                <Spin spinning={loading}>
                    {dataSource.length === 0 ? (
                        <Empty />
                    ) : (
                        <Row gutter={[16, 16]} type="flex">
                            {dataSource.map((item, indexRow) => {
                                return (
                                    <Col key={indexRow} xs={24} sm={24} md={12} lg={12} xl={6}>
                                        <Descriptions
                                            bordered
                                            column={1}
                                            size="small"
                                            layout="vertical"
                                            className={styles["card-description-datagrid"]}
                                        >
                                            {columns.map((column) => {
                                                const dataValue = item[column.dataIndex as string];
                                                return (
                                                    <Descriptions.Item label={column.title}>
                                                        {column.render &&
                                                            column.render(dataValue, item, indexRow)?.children}
                                                    </Descriptions.Item>
                                                );
                                            })}
                                        </Descriptions>
                                    </Col>
                                );
                            })}
                        </Row>
                    )}
                </Spin>
            </Col>
        </Row>
    );
}
